import { activeSessionClaims } from '../http_common.js';
export const COO_LOGIN_PATH = '/administration/coo/login';
export const COO_WORKSPACE_PATH = '/administration/coo-workspace';
export function hasCOOSession(session) {
  const claims = activeSessionClaims(session?.sessionToken, ['STAFF_ACCESS']);
  const role = session?.activeStaff?.role?.name || session?.activeStaff?.role?.code;
  return session?.isAuthenticated === true && role?.toUpperCase?.() === 'COO' &&
    claims?.role === 'COO' && claims?.source === 'universe';
}
